const items = [
  { icon: 'ri-user-heart-line', title: 'Atención profesional' },
  { icon: 'ri-map-pin-user-line', title: '100% local' },
  { icon: 'ri-flashlight-line', title: 'Servicio rápido' },
  { icon: 'ri-shield-check-line', title: 'Productos certificados' },
];

export default function TrustStrip() {
  return (
    <section className="bg-md-navy py-12 md:py-14">
      <div className="mx-auto max-w-[1120px] px-6 md:px-12">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4 md:gap-10">
          {items.map((item) => (
            <div key={item.title} className="flex flex-col items-center text-center">
              <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-white/15 md:h-[56px] md:w-[56px]">
                <span className="flex h-7 w-7 items-center justify-center text-[24px] text-md-light md:text-[28px]">
                  <i className={item.icon} />
                </span>
              </div>
              <h3 className="font-sans text-[15px] font-semibold text-white md:text-[17px]">
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}